import { get as _get } from "lodash";
import api from "../../helpers/api";

export const getSavedSearchList = (variables) => {

  return api().options("/search/saved_search_list", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching saved search list."),
      data: {}
    };
  });
}

export const getSearchTypeList = () => {
  return api().get("/search/search_type").then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", [])
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching search types."),
      data: []
    };
  });
}

export const getHistoryData = (variables) => {

  return api().options("/search/history", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching history data."),
      data: {}
    };
  });
}

export const deleteSavedSearch = (data) => {
  return api().delete("/search/delete_saved_search", { data }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", "Saved search deleted successfully."),
      data: _get(res, "data.responseData", {}),
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while deleting saved search."),
      data: {}
    };
  });
}

export const getExportHistoryData = (variables) => {

  return api().options("/search/export_list", { data: (variables || {}) }).then((res) => {
    return {
      flag: true,
      message: _get(res, "data.responseMessage", ""),
      data: _get(res, "data.responseData", {})
    };
  }).catch((err) => {
    return {
      flag: false,
      message: _get(err, "response.data.responseMessage", "Something went wrong while fetching export history data."),
      data: {}
    };
  });
}
